import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id", "name", "value", "required", "aria-required", "aria-label", "autofocus", "tabindex"]
const _hoisted_2 = {
  key: 0,
  value: ""
}
const _hoisted_3 = {
  key: 1,
  value: "0001"
}
const _hoisted_4 = {
  key: 2,
  value: "0002"
}
const _hoisted_5 = {
  key: 3,
  value: "Z001"
}
const _hoisted_6 = {
  key: 4,
  value: "0003"
}
const _hoisted_7 = {
  key: 5,
  value: "ETG"
}
const _hoisted_8 = {
  key: 6,
  value: "WEG"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("select", {
      id: _ctx.id,
      name: _ctx.id,
      value: _ctx.modelValue,
      class: "c-form-control-select",
      "data-cy": "anrede",
      "data-fehlermeldung": "Bitte wählen Sie eine Anrede aus.",
      required: _ctx.required,
      "aria-required": _ctx.required,
      "aria-label": _ctx.ariaLabel,
      autofocus: _ctx.autofocus,
      tabindex: _ctx.tabindex,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.inputChangeHandler($event))))
    }, [
      (
        _ctx.istVerwalter ||
        _ctx.personAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) ||
        _ctx.firmaAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) ||
        (_ctx.etgAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.wegAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter))
      )
        ? (_openBlock(), _createElementBlock("option", _hoisted_2, " Bitte wählen "))
        : _createCommentVNode("", true),
      (_ctx.personAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.personenAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_3, "Frau"))
        : _createCommentVNode("", true),
      (_ctx.personAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.personenAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_4, "Herr"))
        : _createCommentVNode("", true),
      (_ctx.personAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.personenAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_5, "Divers"))
        : _createCommentVNode("", true),
      (_ctx.firmaAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.firmenAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_6, "Firma"))
        : _createCommentVNode("", true),
      (_ctx.etgAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.gemeinschaftsAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_7, " Eigentümergemeinschaft (EG) "))
        : _createCommentVNode("", true),
      (_ctx.wegAnredeErlaubt(_ctx.piniaStore.state, _ctx.istVerwalter) && _ctx.gemeinschaftsAnrede)
        ? (_openBlock(), _createElementBlock("option", _hoisted_8, " Wohnungseigentümergemeinschaft (WEG) "))
        : _createCommentVNode("", true)
    ], 40, _hoisted_1),
    (_ctx.fehler)
      ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
          key: 0,
          "fehler-text": _ctx.fehler[_ctx.id],
          "reduzierter-abstand": true
        }, null, 8, ["fehler-text"]))
      : _createCommentVNode("", true)
  ], 64))
}